import BrButton from '@govbr/react-components/lib/BrButton';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import auth from '../../auth/Auth';
import authIdPositiva from '../../auth/AuthIdPositiva';
import { authLogout } from '../../auth/authSlice';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import styles from './CaixaMensagemDetalhe.module.css';
import { useHistory } from 'react-router-dom';
import {
  alterarMensagem,
  ativarMensagem,
  getObterDetalhaMensagemPessoa,
  getObterDetalhaMensagemPessoaIdPositiva,
  getObterDetalhaMensagemRL,
  limpar,
  selectMensagemDetalhe,
  selectState,
} from './CaixaMensagemDetalheSlice';
import { getQuantidadeMensagensNaoLidas, getQuantidadeMensagensNaoLidasIdPositiva, getQuantidadeMensagensNaoLidasRL, limparLastApiCallTime } from '../CaixaMensagem/CaixaMensagemSlice';
import { TipoPerfil } from '../../model/TipoPerfil';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';

const CaixaMensagemDetalhe: React.FC<any> = (props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const state = useAppSelector(selectState);
  const mensagemDetalhe = useAppSelector(selectMensagemDetalhe);
  const [mensagemSelecionada] = useState(props.location?.state?.mensagemSelecionada);
  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const voltarParaPainel = async () => {
    history.goBack();
  };

  const irCaixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  useEffect(() => {
    if (mensagemSelecionada) {
      dispatch(limparLastApiCallTime());
      if (auth.isAuthenticated() && perfil) {
        let data = {
          idPessoa: perfil.identificador,
          idMensagemPessoa: mensagemSelecionada.idMensagemDestinatario,
          ponteiroMensagem: 0,
        };
        let perfilRepresentanteLegal = perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL;
        if (perfilRepresentanteLegal) {
          dispatch(getObterDetalhaMensagemRL(data));
        } else{
          dispatch(getObterDetalhaMensagemPessoa(data));
        } 
      } else if (authIdPositiva.isAuthenticated()) {
        let data = {
          idPessoa: authIdPositiva.getUserId(),
          idMensagemPessoa: mensagemSelecionada.idMensagemDestinatario,
          ponteiroMensagem: 0,
        };
        dispatch(getObterDetalhaMensagemPessoaIdPositiva(data));
      }
    }
    return () => {
      dispatch(limpar());
      dispatch(alterarMensagem(''));
      dispatch(ativarMensagem(false));
    };
  }, [dispatch, mensagemSelecionada, perfil]);

  const limparMensagens = () => {
    dispatch(alterarMensagem(''));
    dispatch(ativarMensagem(false));
  };

  const detalharMensagens = (data) => {
    if (auth.isAuthenticated()) {
      
      let perfilRepresentanteLegal = perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL;

      if (perfilRepresentanteLegal) {
        dispatch(getQuantidadeMensagensNaoLidasRL(perfil.identificador));
        dispatch(getObterDetalhaMensagemRL(data));
      } else{
        dispatch(getQuantidadeMensagensNaoLidas(perfil.identificador));
        dispatch(getObterDetalhaMensagemPessoa(data));        
      }
      
    } else if (authIdPositiva.isAuthenticated()) {
      dispatch(getObterDetalhaMensagemPessoaIdPositiva(data));
      dispatch(getQuantidadeMensagensNaoLidasIdPositiva(authIdPositiva.getUserId()));
    }
  }

  const buscarProxima = () => {
    let data = {
      idPessoa: perfil.identificador,
      idMensagemPessoa: mensagemDetalhe.idMensagemDestinatario,
      ponteiroMensagem: 1,
    };
    limparMensagens();

    detalharMensagens(data);
  };

  const buscarAnterior = () => {
    let data = {
      idPessoa: perfil.identificador,
      idMensagemPessoa: mensagemDetalhe.idMensagemDestinatario,
      ponteiroMensagem: -1,
    };
    limparMensagens();

    detalharMensagens(data);
  };

  const obterMensagemComTipo = (mensagem) => {
    setTimeout(() => {
      dispatch(ativarMensagem(false));
    }, 1000000);

    return (
      <div onClick={() => limparMensagens()}>
        <Message id="mensagem" type="warning" title={mensagem} className={styles.message} />
      </div>
    );
  };



  const logout = () => {
    dispatch(limpar());
    dispatch(authLogout({ history }));
  };

  const exibirMensagem = () => {
    return (
      <Card>
        <div className={styles.headerMensagem}>
          <i className={`fas fas fa-envelope-open-text ${styles.iconEnvelope}`} />
          <div>
            {mensagemDetalhe?.dataEnvioMensagem && (
              <span>{moment(mensagemDetalhe?.dataEnvioMensagem).format('DD/MM/YYYY')}</span>
            )}
            {!mensagemDetalhe?.dataEnvioMensagem && mensagemDetalhe?.dataMensagem && (
              <span>{moment(mensagemDetalhe?.dataMensagem).format('DD/MM/YYYY')}</span>
            )}
          </div>
        </div>

        <div className={styles.tituloMensagem}>
          {mensagemDetalhe.tituloMensagem}
        </div>

        <div dangerouslySetInnerHTML={{ __html: mensagemDetalhe.detalheMensagem }}></div>

        <Grid container className={`${styles.buttonBox}`}>
          <Grid item xs={6} className={`${styles.gridCentralizada}`}>
            <BrButton
              className={`${styles.button} ${styles.secondary}`}
              onClick={() => buscarAnterior()}
            >
              Anterior
            </BrButton>
          </Grid>
          <Grid item xs={6} className={`${styles.gridCentralizada}`}>
            <BrButton className={styles.button} onClick={() => buscarProxima()}>
              Próxima
            </BrButton>
          </Grid>
        </Grid>
      </Card>
    );
  };



  return (
    <MainContainer
      navSeparator
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      navGoBack={voltarParaPainel}
      userNav={true}
      titleBarraAuxiliar={"Mensagem"}
      barraAuxiliar={true}
      stoppedTitle={true}
      navFixed
      navCaixaMensagens={irCaixaMensagens}
      navHideArrow={false}
      navLogout={logout}>
      <div className={styles.container}>
        {mensagemDetalhe && exibirMensagem()}
        {state.ativarMensagem && obterMensagemComTipo(state.mensagem)}
      </div>
    </MainContainer>
  );
};

export default CaixaMensagemDetalhe;

